import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const legacyProjectReleasesBambooRoute: InvariantJiraRoute = {
	name: 'legacy-project-releases-bamboo',
	path: '/secure/ConfigureBambooRelease([!%]?[\\w]*).jspa',
};
